import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient , HttpParams} from '@angular/common/http';
import { Router } from '@angular/router';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  //add user form start
  registerForm: FormGroup;
  submitted = false;
  router: any;

  constructor(public fb: FormBuilder, private http: HttpClient, private _router: Router, private crudService: CrudService) {
    this.registerForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      subject: [''],
      message: [''],
    })
  }

  
  baseUrl = this.crudService.baseUrl;

  get f() { return this.registerForm.controls; }

  submitForm() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }
  
    var formData: any = new FormData();

    formData.append("name", this.registerForm.value.name);
    formData.append("email", this.registerForm.value.email);
    formData.append("phone", this.registerForm.value.phone);
    formData.append("subject", this.registerForm.value.subject);
    formData.append("message", this.registerForm.value.message);
    //console.log(formData);
    this.http.post('http://localhost/angular-project/ghrcacs-angular/php_pages/contact.php', formData).subscribe(
      (response) => console.log(response),
      (error) => console.log(error)
    );
    // this.router.navigate(['/demo']);
    this._router.navigateByUrl('/thank-you');
  }

  ngOnInit(): void { 
    var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.nopaperforms.com/emwgts.js"; document.body.appendChild(s);
    // var s=document.createElement("script"); 
    // s.type="text/javascript"; s.async=true; s.src="https://widgets.nopaperforms.com/emwgts.js"; 
    // document.body.appendChild(s);
  
    // var npf_d='https://raisoni.nopaperforms.com'; var npf_c='488'; var npf_m='1'; var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://track.nopaperforms.com/js/track.js"; document.body.appendChild(s); 
    
  }

}
